import { Building2, UserCheck } from "lucide-react";
import type { AppointmentJoin } from "@/repositories/appointments.repository";

type Assignees = Pick<AppointmentJoin, "assigned_organization" | "assigned_user" | "subs_payment" | "individual_payment">;

export function AssigneeSummary({ appointment }: { appointment: Assignees }) {
  const subcontractor = appointment.assigned_organization;
  const worker = appointment.assigned_user?.name ?? null;
  if (subcontractor?.id) {
    return (
      <>
        <Building2 className="w-4 h-4 text-blue-600" />
        <div className="flex flex-col">
          <span className="text-sm font-medium">{subcontractor.display_name ?? ""}</span>
          {worker && <span className="text-xs text-muted-foreground">{worker}</span>}
          {appointment.subs_payment != null && (
            <span className="text-xs text-muted-foreground">Payment - ${appointment.subs_payment.toFixed(2)}</span>
          )}
        </div>
      </>
    );
  }
  if (worker === null) return null;
  return (
    <>
      <UserCheck className="w-4 h-4 text-green-600" />
      <div className="flex flex-col">
        <span className="text-sm font-medium">{worker}</span>
        {appointment.individual_payment != null && (
          <span className="text-xs text-muted-foreground">Payment - ${appointment.individual_payment.toFixed(2)}</span>
        )}
      </div>
    </>
  );
}
